// extracted by mini-css-extract-plugin
export default {"container":"faq-section_container__vDywM","accordion":"faq-section_accordion__BeMrr","color_dimmer":"faq-section_color_dimmer__9stN7","breathe":"faq-section_breathe__Mlkkp"};